import {ReactNode, useEffect, useState} from 'react'
import {createPortal} from 'react-dom'

type Props = {
  children: ReactNode
}

export const FixedFooter = ({children}: Props) => {
  const [footerElement, setFooterElement] = useState<HTMLDivElement | null>(null)
  const [expanderElement, setExpanderElement] = useState<HTMLDivElement | null>(null)

  useEffect(() => {
    const body = document.body
    body.style.height = '100dvh'

    const expander = document.createElement('div')
    expander.classList.add('dcw')
    body.append(expander)
    setExpanderElement(expander)

    const footer = document.createElement('div')
    footer.classList.add('dcw')
    body.append(footer)
    setFooterElement(footer)
  }, [])

  return (
    <>
      <div className="hidden d:block">{children}</div>
      {footerElement &&
        createPortal(
          <div className="fixed d:hidden p-4 bottom-0 left-0 w-full bg-white">{children}</div>,
          footerElement
        )}
      {expanderElement && createPortal(<div className="d:hidden invisible p-4 ">{children}</div>, expanderElement)}
    </>
  )
}
